module.exports = __webpack_public_path__ + "img/cup.551a4f3a.svg";